import Data from "./Data";

export const ACTIONS = {
    setData: (key, value, sub) => {
        return {
            type: "SETDATA",
            key: key,
            value: value,
            sub: sub
        }
    },
    Request: (key) => {
        return {
            type: "REQUEST",
            key: key
        }
    },
    ResponseSuccess: (key, payload, sub) => {
        return {
            type: "SUCCESS",
            key: key,
            payload: payload,
            sub: sub
        }
    },
    ResponseFailed: (key, error) => {
        return {
            type: "FAILED",
            key: key,
            error: error
        }
    },
    setForm: (key, value) => {
        return {
            type: "SETFORM",
            key: key,
            value: value
        }
    },
    setFormObj: (form) => {
        return {
            type: "SETFORMOBJ",
            form: form
        }
    },
    clearForm: () => {
        return {
            type: "CLEARFORM",
        }
    },
    EndLoad: (key) => {
        return {
            type: "ENDLOAD",
            key: key,
        }
    },
};

const Reducer = (state = Data(), action) => {

    switch (action.type) {
        case "SETDATA":
            if (action.sub) {
                if (action.sub === 'data') {
                    return { ...state, data: { ...state.data, [action.key]: action.value } }
                } else {
                    return { ...state, data: { ...state.data, [action.sub]: { ...state.data[action.sub], [action.key]: action.value } } }
                }
            }
            return {
                ...state, [action.key]: action.value
            };

        case "REQUEST":
            return {
                ...state,
                loading: { ...state.loading, [action.key]: true }
            };

        case "SUCCESS":
            if (action.key == '') {
                return {
                    ...state,
                    data: { ...state.data, ...action.payload },
                };
            }
            if (action.sub) {
                return {
                    ...state,
                    data: { ...state.data, [action.sub]: { ...state.data[action.sub], ...action.payload } },
                };
            }
            return {
                ...state,
                data: { ...state.data, [action.key]: action.payload },
            };

        case "FAILED":
            return {
                ...state,
                error: { ...state.error, [action.key]: action.error }
            };
        case "SETFORM":
            return {
                ...state,
                form: { ...state.form, [action.key]: action.value }
            };
        case "SETFORMOBJ":
            return {
                ...state,
                form: action.form
            };
        case "CLEARFORM":
            return {
                ...state,
                form: {}
            };
        case "ENDLOAD":
            return {
                ...state,
                // form: {},
                loading: { ...state.loading, [action.key]: false },
            };
        default:
            return state;
    }

}



export default Reducer;